import { toValidWeekday } from './to-valid-weekday.js';
export function normalizeWeekday(weekDay, firstDayOfWeek, showWeekNumber) {
    const x = toValidWeekday(weekDay - firstDayOfWeek);
    return showWeekNumber ? 1 + x : x;
}
//# sourceMappingURL=normalize-weekday.js.map